class DarkModeToggle extends window.BAO.CustomElement({
  SuperClass: HTMLButtonElement,
}) {
  connectedCallback () {
    super.connectedCallback()

    this.state = {
      isDarkMode: false,
    }

    this.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick () {
    if (this.getAttribute('aria-pressed') === 'true') {
      this.isDarkMode = false
    } else {
      this.isDarkMode = true
    }
  }

  dispatchEvent () {
    const customEvent = new CustomEvent('dark-mode-toggle', {
      detail: {
        isDarkMode: this.isDarkMode,
      },
    })
    window.dispatchEvent(customEvent)
  }

  get isDarkMode () {
    return this.state.isDarkMode
  }

  set isDarkMode (value) {
    this.state.isDarkMode = value

    if (value === true) {
      this.setAttribute('aria-pressed', true)
    } else {
      this.setAttribute('aria-pressed', false)
    }
    this.dispatchEvent()
  }
}

if (!customElements.get('dark-mode-toggle')) {
  customElements.define('dark-mode-toggle', DarkModeToggle, {
    extends: 'button',
  })
}
